namespace GeniuzPOS.InitialData {
    export interface PsPosPrinterForm {
        PrinterId: Serenity.StringEditor;
        PrinterName: Serenity.StringEditor;
    }

    export class PsPosPrinterForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsPosPrinter';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPosPrinterForm.init)  {
                PsPosPrinterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsPosPrinterForm, [
                    'PrinterId', w0,
                    'PrinterName', w0
                ]);
            }
        }
    }
}
